import Hero from "../Component/Hero";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";
import Riplay from "../Component/Riplay";

function InvoiceFinancing() {
    return (
        <>
            <div>
                <Hero
                    imageClass='invoice-financing'
                    title='<em>Invoice Financing</em>'
                    subTitle='P I N J A M A N &emsp;P R O D U K T I F'
                    explanation='Adalah fasilitas pinjaman untuk pelaku usaha yang membutuhkan dana pada saat menunggu proses pembayaran dari pemberi kerja <em>(bowheer)</em> dan/ atau pembeli <em>(buyer)</em> dengan jaminan <em>invoice</em>/faktur yang tertunda. Dengan jangka waktu pencairan sampai dengan 180 hari.'
                    buttonText='AJUKAN PINJAMAN'
                    buttonCompanyWeb={true}
                />
                <Table type='produktif' title='invoice'/>
                {/* <PersyaratanPinjaman type='produktif'/>
                <CardDokumenPendukung type='produktif' product='invoice'/> */}
                <PengajuanPinjaman type='produktif' product='invoice'/>
                <Riplay type='produktif' product='invoice'/>
            </div>
        </>
    );
}

export default InvoiceFinancing;
